import { render, staticRenderFns } from "./dashboardAlert.vue?vue&type=template&id=e1f57c2c&scoped=true"
import script from "./dashboardAlert.vue?vue&type=script&lang=js"
export * from "./dashboardAlert.vue?vue&type=script&lang=js"
import style0 from "./dashboardAlert.vue?vue&type=style&index=0&id=e1f57c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f57c2c",
  null
  
)

export default component.exports